
<div class="loader" [hidden]="status != STATUS_LOADING">
  <div class="dimmed">
    <div class="dimmed_table_box dimmed_table_padding">
      <header>
        <div class="dimmed_flex">
          <div class="dimmed_title"></div>
        </div>
      </header>
      <div class="dimmed_data">
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_title"></div>
      </div>
      <div class="dimmed_data">
        <div class="dimmed_subtitle"></div>
        <div class="dimmed_title"></div>
      </div>
    </div>
  </div>

</div>

<div class="version-add box_default box_white" *ngIf="status == STATUS_DONE && allVersionStatus != null && !creatingNewVersion">
  <header>
    <core-title-section [title]="'Artwork Details'"></core-title-section>
  </header>
  <!-- labels -->
  <article class="project-version-box versions-add-labels " [ngClass]="{'add-version-validation-error': errors.labels}">
    <app-helpers-labels-edit-diff-box
      [edit]="editTagsAccess"
      [project]="project"
      [labels]="versionLabels"
      [headerText]="'TAGS FOR THIS NEW ARTWORK'"
      (labelsChange)="setLabels($event)"
    ></app-helpers-labels-edit-diff-box>
  </article>
  <!-- details -->
  <article class="project-version-box version-add-number" [ngClass]="{'add-version-validation-error': errors.version}">
    <versions-add-number
    [addVersion]="addVersionData"
    [status]="allVersionStatus"
    (formReady)="addChildForm('details', $event)"
    (statusAction)="onSetStatus($event)"
    (addVersionChange)="onAddVersionChange($event)"
    ></versions-add-number>
  </article>
  <article class="project-version-box version-add-status" [ngClass]="{'add-version-validation-error': errors.status}">
    <versions-add-status
      [addVersion]="addVersionData"
      [status]="allVersionStatus"
      (statusAction)="onSetStatus($event)"
      (addVersionChange)="onAddVersionChange($event)"
    ></versions-add-status>
  </article>
  <!-- files -->
  <article class="project-version-box version-upload-section" [ngClass]="{'add-version-validation-error': errors.files}">
    <app-helpers-add-object-files-upload
      [title]="'ARTWORK FILES'"
      (changed)="setFiles($event)"
    ></app-helpers-add-object-files-upload>
  </article>
  <!-- buttons -->
  <div class="box_fieldset">
    <core-helpers-forms-button-white [disabled]="!isVersionReady()" [text]="'Upload Artwork'" (click)= "onSubmit()"></core-helpers-forms-button-white>
    <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel()"></core-helpers-forms-button>
  </div>
</div>
<div [hidden]="!creatingNewVersion" class="loader app-loader">
  <core-helpers-box-loading ></core-helpers-box-loading>
</div>

<div [ngClass]="{'with-overlay': modalView == VIEW_MODAL_UPLOAD_ERROR}">
    <core-layout-modal-feedback class="modal-feedback"  *ngIf="modalView == VIEW_MODAL_UPLOAD_ERROR"
        [type]="'fail'"
        [message]="'Upload Error'"
        [text]="modalUploadErrorText"
        [buttonText]="'OK'"
        (action)="onUploadError($event)">
    </core-layout-modal-feedback>
</div>
